import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'rxnt-stepper',
  templateUrl: './rxnt-stepper.component.html',
  styleUrl: './rxnt-stepper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RxntStepperComponent implements OnChanges {
  @Input() labels: string[] = [];
  @Input() value: string = '';

  valueIndex: number = -1;

  ngOnChanges(changes: SimpleChanges): void {
    // value and labels are this component's only inputs, so every Angular-driven
    // ngOnChanges call carries at least one of them — the else path is unreachable.
    /* v8 ignore else */
    if (changes['value'] || changes['labels']) {
      this.valueIndex = this.labels.indexOf(this.value);
    }
  }
}
